var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_002-information-button",
    "data-name": "002-information-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.787,
    height: 47,
    viewBox: "0 0 47.787 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M23.893,0A23.7,23.7,0,0,0,0,23.5,23.7,23.7,0,0,0,23.893,47,23.7,23.7,0,0,0,47.787,23.5,23.7,23.7,0,0,0,23.893,0Zm4.974,36.42q-1.845.716-2.943,1.09a7.884,7.884,0,0,1-2.553.376A5.144,5.144,0,0,1,19.9,36.814a3.436,3.436,0,0,1-1.236-2.72,9.718,9.718,0,0,1,.091-1.311c.063-.446.162-.947.3-1.51l1.539-5.348c.136-.513.253-1,.346-1.454a6.346,6.346,0,0,0,.138-1.259,1.918,1.918,0,0,0-.429-1.426,2.466,2.466,0,0,0-1.644-.4,4.383,4.383,0,0,0-1.224.179c-.415.125-.775.239-1.07.35l.407-1.647q1.511-.606,2.893-1.036a8.676,8.676,0,0,1,2.609-.434,5.048,5.048,0,0,1,3.422,1.054,3.477,3.477,0,0,1,1.2,2.737q0,.349-.083,1.227a8.093,8.093,0,0,1-.307,1.613l-1.531,5.332a14.873,14.873,0,0,0-.338,1.464,7.62,7.62,0,0,0-.148,1.245,1.771,1.771,0,0,0,.483,1.448,2.741,2.741,0,0,0,1.673.386,4.927,4.927,0,0,0,1.266-.193,7.282,7.282,0,0,0,1.024-.338ZM28.6,14.779a3.689,3.689,0,0,1-2.579.979,3.727,3.727,0,0,1-2.589-.979,3.158,3.158,0,0,1,0-4.753,3.7,3.7,0,0,1,2.589-.989,3.658,3.658,0,0,1,2.579.989,3.17,3.17,0,0,1,0,4.753Z",
    fill: "#00868e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6295a455bcf43851f76a0cae4c57fd05.svg";
export { ForwardRef as ReactComponent };